import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import { Button, FormControl, FormLabel, Modal, Switch, TextareaAutosize, TextField } from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { SelectCargoGrupo } from "../../../../components/selects/cargoGrupo";
import { SelectCargo } from "../../../../components/selects/cargo";
import { SelectSede } from "../../../../components/selects/sede";


export const AtividadeAdd = () => {
  const { goBack, navTo } = useNav();

  const {
    register,
    watch,
    setValue
  } = useForm<{
    descricao: string,
    grupo: number,
    observacoes: string,
    cobranca: boolean,
    sede: number,
    ministerio: number,
    celula: number,
    cargo: number,
    tempomedio: string,
    ministeriogrupo: number,
  }>({
    defaultValues: {
      descricao: null,
      observacoes: null,
      cobranca: false,
      sede: null,
      ministerio: null,
      celula: null,
      cargo: null,
      tempomedio: null,
      ministeriogrupo: null,
      grupo: null
    }
  });


  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal props={{ display: 'grid', rowGap: 1 }}>
          <FormControl fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <SelectCargoGrupo action={(grupo) => { setValue('grupo', grupo?.target?.value) }} valor={watch('grupo')} />
          <SelectSede action={(grupo) => { setValue('sede', grupo) }} value={watch('sede')} />
          <SelectCargo action={(cargo) => { setValue('cargo', cargo?.target?.value) }} valor={watch('cargo')} />
          <FormControl fullWidth>
            <FormLabel >Observações</FormLabel>
            <TextareaAutosize
              {...register('observacoes')}
              style={{
                width: '100%',
                minHeight: 60,
                borderRadius: 4,
                borderColor: '#ccc',
                resize: 'none',
                padding: '4px 8px'
              }}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              {...register('tempomedio')}
              label="Tempo Médio"
              type="time"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <FormControl fullWidth>
            <FormLabel>Cobrar</FormLabel>
            <Switch checked={watch('cobranca')} onChange={(e) => setValue('cobranca', !watch('cobranca'))}/>
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained">Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
